import { ButtonHeading, CommonModal } from "components";
import BootstrapTable from "components/BootstrapTable";
import MastersFilterModal from "modals/MastersFilterModal";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { useDispatch } from "react-redux";
import moment from "moment";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { BsThreeDotsVertical } from "react-icons/bs";
import { getUserList } from "_services/userService";
import useDocumentTitle from "hooks/useDocumentTitle";
import { EditUserProfile } from "modals";
import { getBroadcastingHistoryList, removeLoginSession } from "_services";
import { Images } from "constants";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const BrodcastingHistory = () => {
  useDocumentTitle("User | MySifarish");

  const [showFilterModal, setShowFilterModal] = useState(false);
  const [userListData, setUserListData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 20;
  const [loading, setLoading] = useState(false);
  const [exportLoad, setExportLoad] = useState(false);

  // const [selectedRange, setSelectedRange] = useState({
  //   startDate: "",
  //   endDate: "",
  // });

  // const [filter, setFilter] = useState({
  //   userId: "",
  //   page: 1,
  //   limit: 20,
  //   startDate: "",
  //   endDate: "",
  //   keyword: "",
  //   sourceType: "",
  // });

  const debounceRef = useRef(null);

  const initialFilter = {
    userId: "",
    page: 1,
    limit: 20,
    startDate: "",
    endDate: "",
    keyword: "",
    sourceType: "",
  };

  const [searchParams, setSearchParams] = useSearchParams();

  const [filter, setFilter] = useState({
    ...initialFilter,
    userId: searchParams.get("userId") || "",
    page: Number(searchParams.get("page")) || 1,
    limit: Number(searchParams.get("limit")) || 20,
    sourceType: searchParams.get("sourceType") || "",
    startDate: searchParams.get("startDate")
      ? moment(searchParams.get("startDate"))
      : "",
    endDate: searchParams.get("endDate")
      ? moment(searchParams.get("endDate"))
      : "",
    keyword: searchParams.get("keyword") || "",
  });

  const [selectedRange, setSelectedRange] = useState({
    startDate: filter.startDate,
    endDate: filter.endDate,
  });

  useEffect(() => {
    const params = {};

    Object.entries(filter).forEach(([key, value]) => {
      if (
        value !== "" &&
        value !== null &&
        value !== undefined &&
        !(moment.isMoment(value) && !value.isValid())
      ) {
        params[key] = moment.isMoment(value)
          ? value.format("YYYY-MM-DD")
          : value;
      }
    });

    setSearchParams(params);
  }, [filter, setSearchParams]);

  const handleReset = () => {
    setFilter(initialFilter);
    setSearchParams({});
    setSelectedRange({ startDate: "", endDate: "" });
  };

  const hasActiveFilters = Object.keys(initialFilter).some((key) => {
    if (key === "page" || key === "limit") return false;

    const currentValue = filter[key];
    const initialValue = initialFilter[key];

    const normalize = (val) =>
      val === "" || val === null || val === undefined ? null : val;

    const curr = normalize(currentValue);
    const init = normalize(initialValue);

    if (moment.isMoment(curr)) {
      return (
        curr.isValid() && (!moment.isMoment(init) || !curr.isSame(init, "day"))
      );
    }

    return curr !== init;
  });

  // useEffect(() => {
  //   fetchSifarishPoints();
  // }, [filter, selectedRange]);

  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      fetchSifarishPoints();
    }, 500);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [filter, selectedRange]);

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, page }));
  };

  const renderPagination = () => {
    const totalPages = Math.ceil(totalCount / itemsPerPage);
    const currentPage = filter.page;
    let pages = [];

    const createPageItem = (i) => (
      <li key={i} className={`page-item ${i === currentPage ? "active" : ""}`}>
        <a className="page-link _avPointer" onClick={() => handlePageChange(i)}>
          {i}
        </a>
      </li>
    );

    const rangeStart = Math.max(2, currentPage - 2);
    const rangeEnd = Math.min(totalPages - 1, currentPage + 2);

    pages.push(createPageItem(1));

    if (rangeStart > 2) {
      pages.push(
        <li key="dots-before" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    for (let i = rangeStart; i <= rangeEnd; i++) {
      pages.push(createPageItem(i));
    }

    if (rangeEnd < totalPages - 1) {
      pages.push(
        <li key="dots-after" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    if (totalPages > 1) {
      pages.push(createPageItem(totalPages));
    }

    return (
      <ul className="pagination">
        <li className={`page-item ${filter.page === 1 ? "disabled" : ""}`}>
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter.page - 1)}
          >
            <IoChevronBack />
          </a>
        </li>
        {pages}
        <li
          className={`page-item ${
            filter.page === totalPages ? "disabled" : ""
          }`}
        >
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter.page + 1)}
          >
            <IoChevronForward />
          </a>
        </li>
      </ul>
    );
  };

  const fetchSifarishPoints = async (data) => {
    setLoading(true);
    try {
      const payload = {
        ...filter,
        // startDate: moment(selectedRange.startDate).format("YYYY-MM-DD"),
        // endDate: moment(selectedRange.endDate).format("YYYY-MM-DD"),
        startDate: selectedRange.startDate
          ? moment(selectedRange.startDate).format("YYYY-MM-DD")
          : "",
        endDate: selectedRange.endDate
          ? moment(selectedRange.endDate).format("YYYY-MM-DD")
          : "",
      };
      const res = await getBroadcastingHistoryList(payload);
      if (res) {
        setUserListData(res?.data?.notifications);
        setTotalCount(res?.data?.totalRecords);
        setLoading(false);
      } else {
        toast.error(res?.responseMessage);
        setLoading(false);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setLoading(false);
    }
  };

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";

    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${day}-${month}-${year} | ${hours}:${minutes} ${ampm}`;
  }

  const columns = [
    { header: "", accessor: "seriall" },
    { header: "User Name", accessor: "user_name" },
    { header: "Title", accessor: "title" },
    { header: "Body", accessor: "body" },
    { header: "Type", accessor: "sourceType" },
    { header: "Sent Datetime", accessor: "created_date" },
  ];

  const rowListData = (data) =>
    data?.map((item, i) => ({
      ...item,
      serial: (
        <div className="signDropdown">
          <button className="dropbtn11">
            <BsThreeDotsVertical />
          </button>
        </div>
      ),
      sifarishPoints: item?.sifarishPoints || "-",
      sourceType: (
        <>
          {item?.sourceType && item?.sourceType === 1
            ? "Push"
            : item?.sourceType === 2
            ? "Email"
            : "-"}
        </>
      ),
      created_date: formatDateToDDMMYYYY(item?.createdAt) || "-",
      user_name: (
        <>
          <Link
            to={
              item?.userId?._id
                ? `/user/details/${item?.userId?._id}`
                : undefined
            }
            className="__userPro"
            onClick={(e) => {
              if (!item?.userId?._id) {
                e.preventDefault();
              }
            }}
          >
            <img
              src={item?.userId?.userProfileImageUrl || Images.USERLIMG}
              alt="user Img"
              style={{ borderRadius: "50%" }}
              width={30}
              height={30}
            />
            <span>
              {item?.userId
                ? `${item?.userId?.firstName} ${item?.userId?.lastName}`
                : "User Deleted"}
            </span>
          </Link>
        </>
      ),
    }));

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
    setFilter((s) => ({
      ...s,
      page: 1,
      startDate: newRange.startDate,
      endDate: newRange.endDate,
    }));
  };

  // const exportToCSV = async () => {
  //   try {
  //     const payload = {
  //       ...filter,
  //       limit: -1,
  //       startDate: selectedRange.startDate
  //         ? moment(selectedRange.startDate).format("YYYY-MM-DD")
  //         : "",
  //       endDate: selectedRange.endDate
  //         ? moment(selectedRange.endDate).format("YYYY-MM-DD")
  //         : "",
  //     };

  //     const res = await getBroadcastingHistoryList(payload);

  //     if (
  //       !res ||
  //       !res.data?.notifications ||
  //       res.data.notifications.length === 0
  //     ) {
  //       toast.error("No data to export!");
  //       return;
  //     }

  //     const fullData = res.data.notifications;

  //     const formattedData = fullData.map((item, index) => ({
  //       "Serial No": index + 1,
  //       "User Name":
  //         item?.userId === null
  //           ? "User Deleted"
  //           : `${item?.userId?.firstName} ${item?.userId?.lastName}`,
  //       Title: item?.title || "-",

  //       Body: item?.body || "-",
  //       Type:
  //         item?.sourceType === 1
  //           ? "Push"
  //           : item?.sourceType === 2
  //           ? "Email"
  //           : "-",
  //       "Sent Datetime": formatDateToDDMMYYYY(item?.createdAt) || "-",
  //     }));

  //     const wb = XLSX.utils.book_new();
  //     const ws = XLSX.utils.json_to_sheet(formattedData);

  //     ws["!cols"] = [
  //       { wch: 10 },
  //       { wch: 30 },
  //       { wch: 30 },
  //       { wch: 50 },
  //       { wch: 12 },
  //       { wch: 20 },
  //     ];

  //     XLSX.utils.book_append_sheet(wb, ws, "Broadcast History");

  //     const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //     const blob = new Blob([wbout], { type: "application/octet-stream" });
  //     const epochTime = Date.now();
  //     saveAs(blob,`Broadcast_History_${epochTime}.xlsx`);
  //   } catch (error) {
  //     toast.error(error?.message || "Something went wrong during export.");
  //   }
  // };

  const exportToCSV = async () => {
    const loadingToast = toast.loading(
      "Please wait, Broadcast history is getting exported..."
    );
    setExportLoad(true);

    try {
      const payload = {
        ...filter,
        page: 1,
        limit: 1000,
        startDate: selectedRange.startDate
          ? moment(selectedRange.startDate).format("YYYY-MM-DD")
          : "",
        endDate: selectedRange.endDate
          ? moment(selectedRange.endDate).format("YYYY-MM-DD")
          : "",
      };

      const firstRes = await getBroadcastingHistoryList(payload);

      if (
        !firstRes ||
        !firstRes.data?.notifications ||
        firstRes.data.notifications.length === 0
      ) {
        toast.dismiss(loadingToast);
        toast.error("No data to export!");
        setExportLoad(false);
        return;
      }

      const totalPages = firstRes.data.totalPages || 1;
      const totalRecords =
        firstRes.data.totalRecords || firstRes.data.notifications.length;

      toast.dismiss(loadingToast);
      toast.success(
        `Exporting ${totalRecords} records in ${totalPages} chunks...`
      );

      let allData = [...firstRes.data.notifications];

      for (let page = 2; page <= totalPages; page++) {
        let success = false;
        let retries = 3;

        while (!success && retries > 0) {
          try {
            const res = await getBroadcastingHistoryList({ ...payload, page });
            if (res?.data?.notifications?.length) {
              allData = [...allData, ...res.data.notifications];
            }
            success = true;
          } catch (err) {
            console.warn(`Retrying page ${page}... (${3 - retries + 1})`);
            retries--;
            await new Promise((r) => setTimeout(r, 1000));
          }
        }
      }

      const chunkSize = 10000;
      const numFiles = Math.ceil(allData.length / chunkSize);

      for (let i = 0; i < numFiles; i++) {
        const chunk = allData.slice(i * chunkSize, (i + 1) * chunkSize);

        const filterSummary = [
          {
            Key: "Source Type",
            Value:
              filter?.sourceType === 1
                ? "Push"
                : filter?.sourceType === 2
                ? "Email"
                : "All",
          },
          { Key: "Searched Word", Value: filter?.keyword || "-" },
          {
            Key: "Date Range",
            Value: selectedRange?.startDate
              ? `${moment(selectedRange.startDate).format(
                  "DD-MM-YYYY"
                )} - ${moment(selectedRange.endDate).format("DD-MM-YYYY")}`
              : "All Time",
          },
        ];

        const formattedData = chunk.map((item, index) => ({
          "Serial No": i * chunkSize + index + 1,
          "User Name":
            item?.userId === null
              ? "User Deleted"
              : `${item?.userId?.firstName || "-"} ${
                  item?.userId?.lastName || "-"
                }`,
          Title: item?.title || "-",
          Body: item?.body || "-",
          Type:
            item?.sourceType === 1
              ? "Push"
              : item?.sourceType === 2
              ? "Email"
              : "-",
          "Sent Datetime": formatDateToDDMMYYYY(item?.createdAt) || "-",
        }));

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet([], { skipHeader: true });

        const keyColumn = "C";
        const valueColumn = "D";

        ws[`${keyColumn}1`] = { t: "s", v: "Filter Type" };
        ws[`${valueColumn}1`] = { t: "s", v: "Filter Value" };

        filterSummary.forEach((item, index) => {
          const rowNum = index + 3;
          ws[`${keyColumn}${rowNum}`] = { t: "s", v: item.Key };
          ws[`${valueColumn}${rowNum}`] = { t: "s", v: item.Value };
        });

        XLSX.utils.sheet_add_json(ws, formattedData, {
          origin: "A9",
          skipHeader: false,
        });

        const dataOnly = formattedData.map((r) => r);
        XLSX.utils.sheet_add_json(ws, dataOnly, {
          origin: "A10",
          skipHeader: true,
        });

        ws["!cols"] = [
          { wch: 10 },
          { wch: 30 },
          { wch: 60 },
          { wch: 100 },
          { wch: 15 },
          { wch: 25 },
        ];

        XLSX.utils.book_append_sheet(wb, ws, `Broadcast_${i + 1}`);

        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        const epochTime = Date.now();
        saveAs(blob, `Broadcast_History_Part_${i + 1}_${epochTime}.xlsx`);
      }

      toast.success("All Broadcast history exported successfully!");
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error(error?.message || "Something went wrong during export.");
    } finally {
      setExportLoad(false);
    }
  };

  return (
    <>
      <ButtonHeading
        title={`Broadcast History`}
        showDateRange={true}
        Export={true}
        ExportSubmit={exportToCSV}
        selectedRange={selectedRange}
        filter={filter}
        setFilter={setFilter}
        handleApply={handleApply}
        exportLoad={exportLoad}
        isShow={{
          isSourceType: true,
          keyword: true,
        }}
        handleReset={() => handleReset()}
        showResetFilter={hasActiveFilters}
      />
      <div className="_tabWith_outTab">
        <BootstrapTable
          columns={columns}
          data={rowListData(userListData?.length > 0 ? userListData : [])}
          isLoading={loading}
          colSpan={8}
        />
        <div className="paginationFt_avt">{renderPagination()}</div>
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${
          showFilterModal ? "show" : ""
        }`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? "visible" : "hidden" }}
      >
        {showFilterModal && (
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
          />
        )}
      </div>
      <div className={showFilterModal ? "offBack_drop" : ""}></div>
    </>
  );
};

export default BrodcastingHistory;
